import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';
import { boxShadow } from 'constants/utilsStyles';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: ${boxShadow};
  border-radius: 13px;
  padding: 10px 40px;
  margin-bottom: 10px;
  .card-info-with-img-skeleton {
    display: flex;
    align-items: center;
    .card-info-skeleton {
      display: flex;
      flex-direction: column;
    }
  }
`;

const ContactTileSkeleton = function ContactTileSkeleton() {
  return (
    <Wrapper className='contact-tile-skeleton'>
      <div className='card-info-with-img-skeleton'>
        <SkeletonCustom
          height='60px'
          width='60px'
          diameter='50%'
          margin='0px 5px 5px 5px'
        />
        <div className='card-info-skeleton'>
          <SkeletonCustom
            height='15px'
            width='180px'
            diameter='23px'
            margin='0px 10px 5px'
            marginSm='0px 10px 5px'
          />
          {[1, 2].map(() => (
            <SkeletonCustom
              height='10px'
              width='160px'
              diameter='23px'
              margin='0px 10px 5px'
              marginSm='0px 10px 5px'
            />
          ))}
        </div>
      </div>
      {[1, 2, 3, 4].map(() => (
        <SkeletonCustom
          height='15px'
          width='100px'
          diameter='23px'
          margin='0px'
        />
      ))}
    </Wrapper>
  );
};
export default ContactTileSkeleton;